export default __webpack_public_path__ + "static/media/integral_icon1.9b097825.png";